"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCookieBannerHeading = exports.StyledCookieBannerWrapper = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCookieBannerWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledCookieBannerWrapper", componentId: "sc-11r43mx" }) `
  background: ${(props) => props.theme.colors.white};
  padding: ${(props) => props.theme.spacers.x3};
  border-radius: ${(props) => props.theme.radii.primary};
  position: fixed;
  bottom: ${(props) => props.theme.spacers.x3};
  right: ${(props) => props.theme.spacers.x3};
  z-index: 1;

  ${(props) => (0, ui_1.mq)({
    boxShadow: props.theme.shadows.tertiary,
    width: ['auto', '382px'],
    left: [props.theme.spacers.x3, 'auto'],
})}
`;
exports.StyledCookieBannerHeading = styled_components_1.default.h3.withConfig({ displayName: "StyledCookieBannerHeading", componentId: "sc-1mpjrbh" }) `
  font-size: ${(props) => props.theme.typography.x5.fontSize};
  letter-spacing: ${(props) => props.theme.typography.x5.letterSpacing};
  font-weight: ${(props) => props.theme.fontWeights.semiBold};
  margin: 0 0 ${(props) => props.theme.spacers.x3};
`;
